import React from "react";
import clsx from "clsx";

interface BaseFeedCardProps {
    leadingIcon?: React.ReactNode;
    title: React.ReactNode;
    subtitle?: React.ReactNode;
    meta?: React.ReactNode;
    headerRight?: React.ReactNode;
    content?: React.ReactNode;
    media?: React.ReactNode;
    badgeOverlay?: React.ReactNode;
    actions?: React.ReactNode;
    onClick?: () => void;
    className?: string;
}

const BaseFeedCard: React.FC<BaseFeedCardProps> = ({
    leadingIcon,
    title,
    subtitle,
    meta,
    headerRight,
    content,
    media,
    badgeOverlay,
    actions,
    onClick,
    className,
}) => {
    const mediaContent = media ? (
        <div className="tw-relative tw-rounded-lg tw-overflow-hidden tw-mt-3">
            {media}
            {badgeOverlay}
        </div>
    ) : (
        badgeOverlay && <div className="tw-mt-3">{badgeOverlay}</div>
    );

    return (
        <article className={clsx("tw-pt-4 tw-pb-1 tw-px-4 tw-bg-white tw-mb-2", className)}>
            {(leadingIcon || title) && (
                <div
                    className="tw-flex tw-items-center tw-justify-between tw-gap-3"
                >
                    <div
                        className="tw-flex tw-items-center tw-gap-2 tw-cursor-pointer"
                        onClick={onClick}
                        role={"button"}
                        tabIndex={0}
                        onKeyDown={(event) => {
                            if (!onClick) return;
                            if (event.key === "Enter" || event.key === " ") {
                                event.preventDefault();
                                onClick();
                            }
                        }}
                    >
                        {leadingIcon && (
                            <span className="tw-inline-flex tw-items-center tw-justify-center">{leadingIcon}</span>
                        )}
                        <div className="tw-flex tw-flex-col">
                            <div className="tw-font-merriweather tw-font-semibold tw-text-[19px] tw-leading-tight tw-text-[#111827]">
                                {title}
                            </div>
                            {(subtitle || meta) && (
                                <div className="tw-text-sm tw-text-[#6a6a6a]">
                                    {subtitle || meta}
                                </div>
                            )}
                        </div>
                    </div>
                    {headerRight}
                </div>
            )}

            {content}

            {mediaContent}

            {actions && <div className="tw-mt-2">{actions}</div>}
        </article>
    );
};

export default BaseFeedCard;

